<template>
    <div id="outManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.status" placeholder="状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select v-model="searchForm.sendPerson" @change="changeEnginner" filterable placeholder="送机人" :filter-method="PinyinMatch" clearable>
                    <el-option v-for="(item,index) in pickingList" 
                        :label="item.name" 
                        :value="item.id" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.qrCode" placeholder="请输二维码"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.orderSn" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.phone" placeholder="请输手机号码"></el-input>
            </el-form-item>
            <el-form-item style="width: 20%; margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <!-- <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button> -->
                    <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i> -->
            </el-form-item>
            <el-form-item class="fr">
                <el-col style="text-align:right">
                    
                </el-col>
            </el-form-item>
        </el-form>
        <el-col>
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        prop="orderSn"
                        align="center"
                        width="200"                      
                        label="订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        label="送机方式">
                        <template slot-scope="scope">
                            {{scope.row.sendType | sysCodeFileter('send_machine_way')}}
                        </template>
                    </el-table-column>
                     <el-table-column
                        align="center"
                        prop="engineerName"
                        width="100"
                        label="送机人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        width="150"
                        label="手机号码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="qrCode"
                        width="100"
                        label="二维码">
                    </el-table-column>
                    <el-table-column
                        prop="modelName"
                        align="center"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        prop="colorName"
                        align="center"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="130"
                        label="状态">
                        <template slot-scope="scope">
                            {{scope.row.maintenanceStatus | sysCodeFileter('maintenance_result')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="remark"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="refundReason"
                        label="操作" v-if="basicsAuth.ensure">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == '1'">
                                <span class="active-status" v-if="scope.row.sendType == 3"  @click="confirmBtn1(scope.row)">出库</span>
                                <span v-else class="active-status"  @click="newModel(scope.row)">出库</span>
                            </div>
                            <span v-if="scope.row.status != '1'">已出库</span>                    
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,100,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
        <el-dialog title="提示" width="400px" :visible.sync="dialogFormVisible" >
            <el-form :model="modelForm" :label-position="labelPosition">
                <el-form-item label="门店工程师" label-width="100px">
                    <el-select
                        clearable
                        v-model="modelForm.getMachineName"
                        placeholder="门店工程师">
                        <el-option
                            v-for="(item,index) in engineerDataList"
                            :key="index"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="emptyDialog">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { shopInventoryList,confirmEnsure,engineerList,applyEnginnerList } from "../../../api/api";
    import {getPermission} from '../../../api/authRequest'
    import PinyinMatch from 'pinyin-match'
    export default {
        name: 'outManage',
        data () {
            return {
                pickingStatusList:[
                    {
                        paraName:'待确认',
                        paraCode:'1'
                    },
                    {
                        paraName:'已确认',
                        paraCode:'2'
                    }
                ],
                pickingRepairStatus:[
                    {
                        paraName:'维修完成',
                        paraCode:'1'
                    },
                    {
                        paraName:'维修失败',
                        paraCode:'2'
                    },
                ],
                copy:[],
                pickingList:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    type:"4",
                    sendPerson:'', //送机人
                    qrCode:'',  //二维码编号
                    status:'',  //入库状态
                    orderSn:'',  //关联订单号
                    phone:''
                },
                modelForm:{
                    id:'',
                    orderId:'',
                },
                dialogFormVisible:false,
                returnData: [],
                engineerDataList:[],
                basicsAuth:{
                    ensure:false
                }
            }
        },
        created(){
            this.basicsAuth.ensure = getPermission('/api/shopInventory/ensure');
            this.getEngineerList();
            this.getShopInventoryList();
            this.getApplyEnginnerList();
        },
        methods: {
            //获取送机人
            getApplyEnginnerList() {
                applyEnginnerList({}).then(res => {          
                    if (res.data.status==100) {            
                        this.pickingList = res.data.results;
                        this.copy = Object.assign(this.pickingList); //保留数据源           
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //强制刷新
            changeEnginner(e){
                console.log(e);
                this.searchForm.sendPerson = e; 
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.sendPerson = val;
                    this.pickingList = result;
                }else{
                    this.pickingList = this.copy;
                    this.searchForm.sendPerson = "";
                }
            },
            emptyDialog(){
                this.dialogFormVisible = false;
                this.modelForm = {}
            },
            confirmBtn1(row){
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                let message = '是否确认出库该设备？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.submitConfirmModel()
                }).catch(action => {
                    
                });
            },
            newModel(row){
                console.log(row)
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                if(row.getMachineName){
                    this.modelForm.getMachineName = row.getMachineName
                }
                this.dialogFormVisible = true;
            },
            confirmBtn(){                
                if(!this.modelForm.getMachineName){
                    this.$message({
                        message: '请选择门店工程师',
                        type: "warning"
                    });
                    return;
                }
                this.submitConfirmModel();
            },
            //获取门店工程师列表
            getEngineerList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                    type:'MD',
                    state: 1
                }
                engineerList(params).then(res =>{
                    if(res.data.status == '100'){
                        this.engineerDataList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认收到
            submitConfirmModel(){
                confirmEnsure(this.modelForm).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status=='100') {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        this.emptyDialog();
                        /*刷新*/
                        this.getShopInventoryList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.type="4";
                this.getShopInventoryList();
            },
            //获取退款申请管理列表
            getShopInventoryList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                shopInventoryList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getShopInventoryList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getShopInventoryList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索取机记录
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        this.getShopInventoryList()
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #outManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-status{
            color:#409EFF;
            cursor:pointer
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }
 .hewidth {
        width: 13% !important;
      }
</style>



// WEBPACK FOOTER //
// outManage.vue?076cdb46